/**
 * CloudFront Server-Timing 판독 (브라우저 전용).
 *
 * 문서 응답 헤더는 JS 로 읽을 수 없지만 Server-Timing 만은 브라우저가
 * Performance API 로 노출한다. CF 배포판에 Server-Timing 정책이 켜져 있으면
 * 캐시 히트 여부·POP·요청 고유 ID(cdn-rid)가 들어온다.
 *
 * cdn-rid 는 서버가 받는 `x-amz-cf-id` 와 같은 값이라, 캐시 MISS 요청은
 * 브라우저 로그 ↔ 서버 pino 로그가 요청 단위로 조인된다. HTML 에 아무것도
 * 심지 않으므로 __ssrTraceId 프롭과 달리 캐시 오염 여지가 없다.
 *
 * 정책이 꺼져 있거나 Safari 16.4 미만이면 serverTiming 이 비어 null 을 준다.
 */
export type CdnTiming = {
  zep_cdn_cache?: string;
  zep_cdn_pop?: string;
  zep_cdn_rid?: string;
};

export const parseCdnServerTiming = (
  entries: readonly PerformanceServerTiming[],
): CdnTiming | null => {
  const timing: CdnTiming = {};
  for (const entry of entries) {
    if (entry.name.startsWith('cdn-cache-')) {
      timing.zep_cdn_cache = entry.name.slice('cdn-cache-'.length);
    } else if (entry.name === 'cdn-pop') {
      timing.zep_cdn_pop = entry.description;
    } else if (entry.name === 'cdn-rid') {
      timing.zep_cdn_rid = entry.description;
    }
  }
  return Object.keys(timing).length > 0 ? timing : null;
};

export const readCdnServerTiming = (): CdnTiming | null => {
  const [navigation] = performance.getEntriesByType(
    'navigation',
  ) as PerformanceNavigationTiming[];
  return parseCdnServerTiming(navigation?.serverTiming ?? []);
};
